import { cva } from "class-variance-authority";

/**
 * Canonical surface/card shell variants — una escala de ELEVACIÓN, no una
 * paleta de fondos. `--card` y `--background` son casi el mismo valor en los
 * dos temas (light #ffffff vs #f5f7fa, dark #0f172a vs #121212), así que la
 * separación card↔fondo la dan el BORDE + la SOMBRA, nunca el fill solo. Por
 * eso `card` es opaca y lleva `shadow-sm`: la variante translúcida anterior
 * (`bg-card/40`, sin sombra) era invisible sobre el fondo del dashboard, y por
 * eso ~46 sitios habían caído en `glass-card` a mano para verse como card.
 *
 * Regla de uso:
 * - `card`  (default) — la card de contenido de una página. Una card `card`
 *   NUNCA contiene otra `card`; lo de adentro va `plain`.
 * - `flat`  — card de superficie pública: opaca y sin sombra.
 * - `plain` — bloque anidado dentro de una card. Sólo borde.
 *
 * Había también `muted` y `glass`, y los radios `lg` y `3xl`: se borraron el
 * 2026-08-26 con CERO consumidores entre los 74 <Panel> del repo. Para algo
 * que flota SOBRE contenido (modal, barra sticky, HUD) se usa la utilidad
 * `glass-card` directo, que es lo que ya hacían sus dos únicos usuarios.
 * Volver a agregar cualquiera de los cuatro es una línea, cuando haya un caso
 * real que lo pida.
 */
export const panelVariants = cva("transition-surface", {
  variants: {
    surface: {
      card: "surface-card",
      // Card de superficie PUBLICA: fill opaco + borde, sin elevacion — la
      // regla "planas" del 2026-08-26. Faltaba en la escala, asi que la
      // landing la hand-rolleaba: el FAQ con `bg-card` + `shadow-sm` y la
      // card de precios con `bg-card/15`, o sea 85% transparente.
      flat: "border border-border/60 bg-card",
      plain: "border border-border/40 bg-transparent",
    },
    radius: {
      xl: "rounded-xl",
      "2xl": "rounded-2xl",
    },
    pad: {
      none: "",
      sm: "p-4",
      md: "p-6",
      lg: "p-8",
    },
    hover: {
      true: "hover:border-primary/30 hover:bg-muted/40 hover:shadow-md",
      false: "",
    },
  },
  defaultVariants: {
    surface: "card",
    radius: "2xl",
    pad: "md",
    hover: false,
  },
});
